import { render, staticRenderFns } from "./Categorys.vue?vue&type=template&id=574412e8"
import script from "./Categorys.vue?vue&type=script&lang=js"
export * from "./Categorys.vue?vue&type=script&lang=js"
import style0 from "./Categorys.vue?vue&type=style&index=0&id=574412e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports